import { create } from 'zustand';
import type { CompanyLayer } from '@/services/workspace.service';

/**
 * Which company layer is being drawn into, if any: one at a time, as in QGIS's edit mode. The workspace panel starts
 * it ("Edit features"), the editing host on the map shows the tools while it is set.
 */
interface EditingState {
  layer: CompanyLayer | null;
  start: (layer: CompanyLayer) => void;
  stop: () => void;
}

export const useEditingStore = create<EditingState>((set) => ({
  layer: null,
  start: (layer) => set({ layer }),
  stop: () => set({ layer: null }),
}));

/** Whether a layer of the list may be drawn into here: a company layer with a geometry the person may change. */
export function editable(layer: CompanyLayer): boolean {
  return !!layer.canUpdate && !layer.dataOnly && !!layer.geometry;
}
